import React from 'react';
import { motion } from 'framer-motion';

const Problem = () => {
  return (
    <section id="problem" className="py-20 bg-gradient-to-br from-gray-900 to-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-8">
            You lose customers in the first 5 seconds
          </h2>
          
          <div className="space-y-6 text-lg text-white/80">
            <p>
              When potential customers find your business online, they make instant judgements about your professionalism and trustworthiness.
            </p>
            
            <p>
              Your competitors are winning jobs not because they're better tradespeople, but because they <em>look</em> more professional online.
            </p>
            
            <p>
              With 85% of customers browsing on mobile and making quick decisions based on Google search results, 
              your website needs to build trust immediately or they'll call someone else.
            </p>
            
            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-6 mt-8">
              <p className="text-red-300 font-semibold">
                Every day you wait, competitors are booking the jobs you should be getting.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Problem;